export function toSdkApiBase(apiUrl: string): string {
  return apiUrl.replace(/\/(api\/v1|api|v1)\/?$/, '');
}
